/* Revy bundles use Shopify Functions; its full-page reload after every cart change is not needed. */
window.revyBundleThemeSettings=Object.assign(window.revyBundleThemeSettings||{},{disableReloadOnCartUpdate:true});
(function(){
  if(window.__kpQuickAdd) return; window.__kpQuickAdd=true;
  function place(){
    document.querySelectorAll('.kp-qa-host[data-kp-qa-img]').forEach(function(h){
      var img=h.querySelector(h.getAttribute('data-kp-qa-img')), b=h.querySelector('.kp-qa'); if(!img||!b) return;
      var hr=h.getBoundingClientRect(), ir=img.getBoundingClientRect(), g=b.offsetWidth<40?6:12;
      b.style.top=(ir.bottom-hr.top-b.offsetHeight-g)+'px'; b.style.left=(ir.right-hr.left-b.offsetWidth-g)+'px';
      h.classList.add('kp-qa-ready');
    });
  }
  window.addEventListener('load',place); window.addEventListener('resize',place); document.addEventListener('DOMContentLoaded',place); setTimeout(place,1500);
  function cartIcon(){
    var els=[].slice.call(document.querySelectorAll('a.navlink--cart, header a[href$="/cart"], .site-header a[href$="/cart"], a[href="/cart"]'));
    for(var i=0;i<els.length;i++){var r=els[i].getBoundingClientRect(); if(r.width>0&&r.height>0) return els[i];}
    return null;
  }
  function toast(){
    var t=document.getElementById('kp-qa-toast');
    if(!t){t=document.createElement('div');t.id='kp-qa-toast';t.className='kp-qa-toast';t.setAttribute('role','status');t.setAttribute('aria-live','polite');
      t.innerHTML='<span class="kp-qa-toast__ok" aria-hidden="true">✓</span><span>Tillagd i varukorgen</span><a href="/cart">Visa varukorg</a>';document.body.appendChild(t);}
    t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
    clearTimeout(t._h); t._h=setTimeout(function(){t.classList.remove('is-on')},3200);
  }
  function bump(icon,cart){
    document.querySelectorAll('[data-header-cart-count]').forEach(function(e){ e.setAttribute('data-header-cart-count',cart.item_count); if(/\d/.test(e.textContent)) e.textContent=e.textContent.replace(/\d+/,cart.item_count); });
    if(icon){icon.classList.remove('kp-qa-bounce'); void icon.offsetWidth; icon.classList.add('kp-qa-bounce');}
    toast();
  }
  function fly(b,cart){
    var host=b.closest('.kp-qa-host')||b.parentNode, img=host&&host.querySelector('img'), icon=cartIcon();
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!img||!icon||reduce){bump(icon,cart);return;}
    var s=img.getBoundingClientRect(), r0=icon.getBoundingClientRect(), d={left:r0.left,width:r0.width,height:r0.height,top:Math.max(8,Math.min(r0.top,window.innerHeight-r0.height-8))};
    var c=img.cloneNode(); c.removeAttribute('srcset'); c.removeAttribute('sizes'); c.src=img.currentSrc||img.src; c.className='kp-qa-fly';
    var sz=Math.min(s.width,s.height,160);
    c.style.cssText='left:'+(s.left+s.width/2-sz/2)+'px;top:'+(s.top+s.height/2-sz/2)+'px;width:'+sz+'px;height:'+sz+'px';
    document.body.appendChild(c);
    var dx=d.left+d.width/2-(s.left+s.width/2), dy=d.top+d.height/2-(s.top+s.height/2);
    var a=c.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:'translate('+dx*0.5+'px,'+(dy*0.5-60)+'px) scale(.55)',opacity:.95},{transform:'translate('+dx+'px,'+dy+'px) scale(.12)',opacity:.4}],{duration:750,easing:'cubic-bezier(.5,0,.75,.35)'});
    a.onfinish=function(){c.remove();bump(icon,cart);};
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('button[data-kp-qa]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    if(b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(b.getAttribute('data-kp-qa')),quantity:1}]})})
      .then(function(r){ if(!r.ok) throw r; return fetch('/cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('theme:cart:change',{detail:{cart:cart},bubbles:true}));
        b.classList.remove('is-loading'); b.classList.add('is-added');
        setTimeout(function(){b.classList.remove('is-added')},1600);
        fly(b, cart);
      })
      .catch(function(){ b.classList.remove('is-loading'); window.location.href=b.getAttribute('data-kp-qa-url'); });
  },true);
})();
